// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PExportOutlinedSvg from "@fishx/icons-svg/es/asn/PExportOutlined";
import FishxIcon from '../components/FishxIcon';

var PExportOutlined = function PExportOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PExportOutlinedSvg
  }));
};

PExportOutlined.displayName = 'PExportOutlined';
export default React.forwardRef(PExportOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PExportOutlined.js
// module id = 3363
// module chunks = 0